import React from "react";
import { Download } from "lucide-react";

const DataExport = ({ onExport }) => {
  return (
    <div className="flex justify-end w-full">
      <div
        onClick={onExport}
        className="flex items-center gap-fluid-1 cursor-pointer text-[#030229] hover:underline transition-colors duration-300"
      >
        <Download size={20} strokeWidth={2} className="text-[#030229]" />
        <span className="font-bold text-fluid-base underline-offset-4">
          Export data
        </span>
      </div>
    </div>
  );
};

export default DataExport;
